module.exports = __webpack_public_path__ + "img/logo-maxads.88316f3e.png";